/**
 * Een bericht klaarzetten voor de groepsapp. wa.me opent WhatsApp met de
 * tekst al ingevuld; de gebruiker kiest zelf naar wie en verstuurt zelf.
 * Met een nummer gaat het meteen naar die ene persoon (de uitnodigingslade),
 * zonder nummer kies je in WhatsApp zelf een chat of groep.
 */
export function waHref(tekst: string, nummer?: string | null) {
	const cijfers = nummer?.replace(/\D/g, '') ?? ''
	return `https://wa.me/${cijfers}?text=${encodeURIComponent(tekst)}`
}

type Klik = {
	preventDefault(): void
	button?: number
	metaKey?: boolean
	ctrlKey?: boolean
	shiftKey?: boolean
	altKey?: boolean
}

/**
 * De deelknop als upgrade van een gewone link. Zonder JavaScript volgt de
 * browser de wa.me-link, en op de computer blijft dat zo: daar opent wa.me
 * WhatsApp Web, precies wat de knop belooft. Alleen op een aanraakscherm
 * met navigator.share opent het deelmenu van het toestel. Een klik met een
 * toets erbij of met de middelste knop blijft van de browser (nieuw
 * tabblad). Tekst en link gaan als één tekst mee: WhatsApp op de iPhone
 * laat de tekst vallen als er ook een losse url bij zit. Wegtikken van het
 * menu (AbortError) is geen fout. Weigert het toestel om een andere reden,
 * dan gaat de pagina alsnog naar wa.me; window.open zou na de weigering
 * door de popupblokker worden tegengehouden.
 */
export function deelOfWa(event: Klik, tekst: string, href: string) {
	if ((event.button ?? 0) !== 0) return
	if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
	if (typeof window === 'undefined' || typeof navigator === 'undefined') return
	if (typeof navigator.share !== 'function') return
	if (!window.matchMedia?.('(pointer: coarse)').matches) return
	const deel = { text: tekst }
	if (navigator.canShare?.(deel) === false) return
	event.preventDefault()
	navigator.share(deel).catch((fout: unknown) => {
		// DOMException is niet overal een Error: kijk alleen naar de naam
		if ((fout as { name?: unknown } | null)?.name === 'AbortError') return
		window.location.assign(href)
	})
}
